import { useCallback } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';
import { useNavigate } from '@interlayer/js/hooks/navigate';
import { QUERY_PARAMS } from '@interlayer/js/app/hooks/useQueryParam/constants';
import { useLoginPopup } from '@interlayer/js/components/popups/LoginPopup/hooks';
import { useSmartClosePopups } from '@interlayer/js/components/common/PopupManager/hooks/useSmartClosePopups';

export type TUseShowLoginNotification = {
    ID: string;
    data?: {
        afterLoginUrl?: string;
    };
}

export const useHandleShowLoginNotification = () => {
    const navigate = useNavigate();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();
    const loginPage = useAppSelector(prop('loginPage'));

    return useCallback((options: TUseShowLoginNotification) => {
        const separator = loginPage && loginPage.includes('?') ? '&' : '?' ;

        if (loginPage && options?.data?.afterLoginUrl) {
            closePopups();
            navigate(
                `${loginPage}${options.data?.afterLoginUrl
                    ? `${separator}${QUERY_PARAMS.afterLoginUrl}=${encodeURIComponent(options.data.afterLoginUrl)}`
                    : ''}`
            );
        } else {
            showLoginPopup();
        }
    }, [closePopups, loginPage, navigate, showLoginPopup]);
};
